var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.totalPendentes > 0)?_c('v-btn',{staticClass:"text-none",staticStyle:{"box-shadow":"none"},attrs:{"icon":"","aria-label":"Justificativas de falta aguardando análise"},on:{"click":_vm.irParaListagem}},[_c('v-badge',{attrs:{"content":_vm.totalPendentes,"color":"error"}},[_c('v-icon',[_vm._v("mdi mdi-alpha-j-box-outline")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }